import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=295909bb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295909bb')) {
      api.createRecord('295909bb', component.options)
    } else {
      api.reload('295909bb', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=295909bb&", function () {
      api.rerender('295909bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/auth/Auth.vue"
export default component.exports